import { useEffect } from 'react';
import bookingSagaWatcher from '../store/sagas';
import bookingReducer from '../store';
import { injectSaga } from '@app/store/rootSaga';
import { injectReducer } from '@app/store';

export const useBookingChunk = () => {
    useEffect(() => {
        injectReducer('booking', bookingReducer);
        injectSaga('booking', bookingSagaWatcher);
    }, []);
};
